import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

export type ForYouPageHeaderMetaProps = {
    baseUrl: string;
    tab: string;
};

const ForYouPageHeaderMeta = ({ baseUrl, tab }: ForYouPageHeaderMetaProps) => {
    const { formatMessage } = useIntl();

    let title = formatMessage({ id: 'forYou.auctioneersTab' });

    if (tab === 'for-you') {
        title = formatMessage({ id: 'forYou.itemsTab' });
    } else if (tab === 'followed-searches') {
        title = formatMessage({ id: 'forYou.searchesTab' });
    }
    title = useAddNotificationCountToTitle(title);
    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const canonical = `${baseUrl}/dashboard/`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo<ForYouPageHeaderMetaProps>(ForYouPageHeaderMeta);
